import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { FormControlLabel, Radio, RadioGroup } from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { Trans } from "@lingui/macro";
import { responseProtocol } from "../../utils/protocole";
import { showBtnNext } from "../../actions";

class FormProtocol extends Component {
  state = {
    resultForm: [],
    select: {},
    radio: {}
  };

  componentDidMount() {
    this.props.step.data.fetchSource &&
      this.props.fetchData(this.props.step.data.fetchSource);
    this.props.showBtnNext(true);
  }

  getData = () => {
    const dataKey = this.props.step.data.keyValue;
    if (this.props.dataSource && this.props.dataSource[dataKey]) {
      return this.props.dataSource[dataKey];
    }
    return null;
  };

  getRenderForm = data => {
    return data.map((item, key) => {
      switch (item.typepchamp) {
        case "interv":
          return this.getInterv(item, `interv-${key}`, key);
        case "list":
          return this.getList(item, `list-${key}`, key);
        case "radio":
          return this.getRadio(item, `radio-${key}`, key);
        default:
          return null;
      }
    });
  };

  getInterv = (item, key, index) => {
    let min = 0,
      max = 0;
    if (item.list && item.list.length) {
      min = parseInt(item.list[0].valeurinf);
      max = parseInt(item.list[0].valeurmax);
    }
    return (
      <div className="raw-form" key={key}>
        <label className="title-line-form">{item.question}</label>
        <input
          onChange={e => this.handleChangeInterv(e, index, min, max)}
          type="text"
        />
      </div>
    );
  };
  handleChangeInterv = (e, index, min, max) => {
    const value = parseInt(e.target.value);
    const resultForm = [...this.state.resultForm];
    resultForm[index] = 1;
    if (value <= max && value >= min) {
      resultForm[index] = 0;
    }
    this.setState({ resultForm });
  };
  getList = (item, keyParent, index) => {
    const html = item.list.map((element, key) => {
      return (
        <MenuItem
          key={key}
          value={`${index}-${key}-${element.valeur}`}
          datavalue={element.valeur}
        >
          {element.libelle}
        </MenuItem>
      );
    });
    return (
      <div className="raw-form" key={keyParent}>
        <label className="title-line-form">{item.question}</label>
        <div className="wrap-input">
          <Select
            value={this.state.select[index] || ""}
            onChange={e => this.handleChangeSelect(e, index)}
          >
            {html}
          </Select>
        </div>
      </div>
    );
  };
  handleChangeSelect = (e, index) => {
    const value = e.target.value;
    const dataValue = e.currentTarget.attributes.datavalue.value;
    const resultForm = [...this.state.resultForm];
    resultForm[index] = dataValue;
    const selectValue = { ...this.state.select, ...{ [index]: value } };
    this.setState({ resultForm, select: selectValue });
  };

  getRadio = (item, keyParent, index) => {
    const html = item.list.map((element, key) => {
      return (
        <FormControlLabel
          key={key}
          value={`${index}-${key}-${element.valeur}`}
          control={<Radio color="primary" />}
          label={
            <div className="lowercase">
              <span>{element.libelle}</span>
            </div>
          }
          labelPlacement="end"
        />
      );
    });
    return (
      <div className="raw-form" key={keyParent}>
        <span className="title-line-form label-radio">{item.question}</span>
        <RadioGroup
          aria-label={item.question}
          name={`${keyParent}-chooser`}
          className="flex-direction-row"
          onChange={e => this.handleChangeRadio(e, index)}
        >
          {html}
        </RadioGroup>
      </div>
    );
  };
  handleChangeRadio = (e, index) => {
    const value = e.target.value;
    const dataValue = value.split("-")[2];
    const resultForm = [...this.state.resultForm];
    resultForm[index] = dataValue;
    const radioValue = { ...this.state.radio, ...{ [index]: value } };
    this.setState({ resultForm, radio: radioValue });
  };
  handleClick = e => {
    e.preventDefault();
    const value = this.state.resultForm.join("");
    this.props.responseProtocol(value, this.props.step.response);
  };

  render() {
    const { step } = this.props;
    const data = this.getData();
    return (
      <React.Fragment>
        {data && (
          <React.Fragment>
            <span className="label">
              {step.icon && <img src={step.icon} alt={step.label} />}
              {step.label}
            </span>
            {this.getRenderForm(data)}
            <div className="bottom">
              <button
                onClick={this.handleClick}
                disabled={
                  this.state.resultForm.length !== this.getData().length ||
                  this.state.resultForm.includes(undefined)
                }
                className="custom-btn"
              >
                <Trans id="W_STEP_BOUTON_CONTINUER" />
              </button>
            </div>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

FormProtocol.propTypes = {
  dataSource: PropTypes.any,
  fetchData: PropTypes.func,
  responseProtocol: PropTypes.func,
  showBtnNext: PropTypes.func,
  step: PropTypes.shape({
    data: PropTypes.shape({
      fetchSource: PropTypes.func,
      keyValue: PropTypes.any
    }),
    icon: PropTypes.any,
    label: PropTypes.any,
    response: PropTypes.any
  })
};

const mapStateToProps = state => {
  return {
    dataSource: state.dataSource
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchData: functionName => dispatch(functionName()),
    responseProtocol: (value, response) =>
      dispatch(responseProtocol(value, response)),
    showBtnNext: isShow => dispatch(showBtnNext(isShow))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FormProtocol);
